'use client';
import classNames from 'classnames';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { BtnSingProps } from 'eco-design-micro/props/btn/BtnSingProps';
import EcoLink from 'eco-design/base/eco-link';
import './index.scss';
export interface EcoButtonProps extends BtnSingProps {
    /**
     * 样式类
     */
    className?: string;
}

/**
 * 按钮用于开始一个即时操作。
 */
export default function EcoButton({
    lTheme = 'blue',
    lType = 'filled',
    lSize = 'medium',
    lRadius = 'normal',
    lHref,
    lDisabled,
    lFontColor,
    lBorderColor,
    lBgColor,
    lIconL,
    lIconR,
    lChildren,
    children,
    className,
    lDataLayer,
    lIsWithRightArrow,
    ...props
}: EcoButtonProps) {
    const prefixCls = 'eco-button';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${lTheme}`]: lTheme,
        [`${prefixCls}-type-${lType}`]: lType,
        [`${prefixCls}-size-${lSize}`]: lSize,
        [`${prefixCls}-radius-${lRadius}`]: lRadius,
        [`${prefixCls}-disabled`]: lDisabled,
    });

    const compStyle = {
        '--btn-fontColor': lFontColor,
        '--btn-bgColor': lBgColor,
        '--btn-borderColor': lBorderColor || lBgColor,
    };
    if (!lChildren && !children) {
        return null;
    }
    let lIconR2 = lIconR || null;
    if (lIsWithRightArrow) {
        lIconR2 = <EcoIconArrow className={`${prefixCls}-icon-arrow`} />;
    }

    return (
        <EcoLink className={compCls} {...props} dataLayer={lDataLayer} style={compStyle} href={lHref}>
            {lIconL && <span className={`${prefixCls}-icon-l`}>{lIconL}</span>}
            <span className={`${prefixCls}-msg`}>{lChildren || children}</span>
            {lIconR2 && <span className={`${prefixCls}-icon-r`}>{lIconR2}</span>}
        </EcoLink>
    );
}
